import { useMemo } from 'react';

import { useIntl } from 'react-intl';

// eslint-disable-next-line import/order
import type { JSONDocNode } from '@atlaskit/editor-json-transformer/types';

import { getTranslatedItemTitle } from '../prebuilt/config-items/config-items';
// eslint-disable-next-line import/order
import type { LatestPrompt } from '../utils/xstate/get-ai-experience-service';

export function useLocalizedLatestPrompt(latestPrompt: LatestPrompt | undefined):
	| {
			presetTitle: string;
			userADFInput: JSONDocNode | undefined;
			userInput: string | undefined;
	  }
	| {
			presetTitle?: undefined;
			userADFInput: JSONDocNode | undefined;
			userInput: string;
	  } {
	const { formatMessage } = useIntl();

	return useMemo(() => {
		return latestPrompt?.presetTitle
			? {
					presetTitle: getTranslatedItemTitle(latestPrompt.presetTitle, formatMessage),
					userInput: latestPrompt?.userInput,
					userADFInput: latestPrompt?.userADFInput,
				}
			: {
					userInput: latestPrompt?.userInput || '',
					userADFInput: latestPrompt?.userADFInput,
				};
	}, [latestPrompt, formatMessage]);
}
